<!-- Main content -->
<!-- Default box -->
<app-register></app-register>
<!-- /.card -->
<!-- /.content -->